import { getBackendOrigin } from '@/utils/apiOrigin'
import { getApiBaseUrl } from '@/config/apiBase'

export function resolvePublicAssetUrl(path: string | null | undefined): string {
  if (!path?.trim()) return ''
  const trimmed = path.trim()
  if (
    trimmed.startsWith('http://') ||
    trimmed.startsWith('https://') ||
    trimmed.startsWith('data:') ||
    trimmed.startsWith('blob:')
  ) {
    return trimmed
  }

  const normalized = trimmed.startsWith('/') ? trimmed : `/${trimmed}`

  if (normalized.startsWith('/finance/attachments/')) {
    return `${getApiBaseUrl()}${normalized}`
  }

  if (normalized.startsWith('/pj-nf/attachments/')) {
    return `${getApiBaseUrl()}${normalized}`
  }

  const legacyContractMatch = normalized.match(/^\/uploads\/finance\/([^/]+)\/(.+\.pdf)$/i)
  if (legacyContractMatch) {
    const [, projectId, filename] = legacyContractMatch
    if (projectId !== 'requests') {
      return `${getApiBaseUrl()}/finance/attachments/contracts/${projectId}/${filename}`
    }
  }

  const legacyFinanceMatch = normalized.match(/^\/uploads\/finance\/requests\/([^/]+)\/(.+)$/)
  if (legacyFinanceMatch) {
    const [, userId, filename] = legacyFinanceMatch
    return `${getApiBaseUrl()}/finance/attachments/requests/${userId}/${filename}`
  }

  if (normalized.startsWith('/uploads/')) {
    return `${getBackendOrigin()}${normalized}`
  }

  // Assets do app (crm-app/public) — mesma origem do SPA.
  return normalized
}
